import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react-lite';
import isEmpty from 'lodash/isEmpty';
import {useLocation} from 'react-router-dom';
import {AppContext} from '../../../store';
import AttendeeOpenChatBtn from '../AttendeeOpenChatBtn';
import AttendeeBtnsMore from '../AttendeeBtnsMore';
import InvitationButton from '../../invitations/InvitationButton';
import './AttendeeButtons.scss';

const AttendeeButtons = observer(props => {
    const {attendee, width} = props;
    const {userStore} = React.useContext(AppContext);
    const {user} = userStore;
    const location = useLocation();
    const openedAttendeeFromChat = location.state ? location.state.openedFromChat : null;
    console.log('menuClass', props.menuClassName);

    return !isEmpty(attendee) ? (
        <div className={props.className}>
            <div className={'attendee-buttons'}>
            <AttendeeOpenChatBtn attendee={attendee}/>
            {!openedAttendeeFromChat ? <InvitationButton attendee={attendee} containerWidth={width}/> : null}
            </div>
            <AttendeeBtnsMore attendee={attendee} user={user}/>
        </div>
    ) : null;
});

AttendeeButtons.propTypes = {
    attendee: PropTypes.oneOfType([PropTypes.object]),
    menuClassName: PropTypes.string,
};

AttendeeButtons.defaultProps = {
    attendee: {},
};

export default AttendeeButtons;
